import { IControllerConstructor } from 'angular';
import { UnratedJourneysController } from './unrated-journeys.controller';

/**
 * The entry point the unrated journeys module
 */
export const initialise = () => {

  angular.module('app.unrated-journeys', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ]).config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('unrated-journeys', {
      url: '/unrated-journeys',
      templateUrl: 'app/angularJS/features/abt/unrated-journeys/unrated-journeys.html',
      controller: 'unratedJourneysController',
      controllerAs: 'vm',
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }])
  .controller('unratedJourneysController', <IControllerConstructor>UnratedJourneysController);
};